export default "__VITE_ASSET__4GMNry5S__"